var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"sidebar-item overflow-hidden"},[_c('div',{staticClass:"vx-row item-details no-gutter"},[_c('div',[_vm._v(_vm._s(_vm.item.name))]),_c('div',{staticClass:"ml-auto"},[_c('vs-checkbox')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }